import type { LevelDef } from '../levels';
import { LEVEL_PYRAMID } from './level-pyramid';
import { LEVEL_DIAMOND } from './level-diamond';
import { LEVEL_TEMPLE }  from './level-temple';

export { LEVEL_PYRAMID } from './level-pyramid';
export { LEVEL_DIAMOND } from './level-diamond';
export { LEVEL_TEMPLE }  from './level-temple';

export const LEVELS: LevelDef[] = [LEVEL_PYRAMID, LEVEL_DIAMOND, LEVEL_TEMPLE];
